/**
 * Created by hernanherreros on 2019-09-27
 */

import * as React from 'react'
import { Col, Pagination, Row } from 'antd'
import styled from 'styled-components'
import ActivityCard from './ActivityCard'
import { useState } from 'react'

const PAGE_SIZE = 6

interface Props {
  activities: any[];
}

export default function ActivitiesPage ({ activities }: Props) {
  const [page, setPage] = useState(1)

  const pageActivities = activities.slice((page - 1) * 6, page * 6)

  const columnLength = Math.ceil(pageActivities.length / 2)
  const left = pageActivities.slice(0, columnLength)
  const right = pageActivities.slice(columnLength, columnLength * 2)

  return (
    <DayPageContainer>
      <Row gutter={16}>
        <Col lg={12}>
          {left.map((a: any) => (
            <ActivityCard
              key={a.ID}
              id={a.ID}
              isInscribable={a.IsInscribable}
            />
          ))}
        </Col>
        <Col lg={12}>
          {right.map((a: any) => (
            <ActivityCard
              key={a.ID}
              id={a.ID}
              isInscribable={a.IsInscribable}
            />
          ))}
        </Col>
      </Row>
      <PaginationContainer>
        <Pagination
          defaultCurrent={1}
          total={activities.length}
          pageSize={PAGE_SIZE}
          onChange={setPage}
        />
      </PaginationContainer>
    </DayPageContainer>
  )
}

const DayPageContainer = styled.div`
  padding: 20px 0;
`

const PaginationContainer = styled.div`
  margin-top: 20px;
  
  display: flex;
  justify-content: center;
`